import moment from 'moment';
import { isEmpty, get } from 'lodash';
import { Base64 } from 'js-base64';
import qs from 'qs';
import sha256 from 'sha256';
// import { DEBUG_FLAG } from '@/constants/config';
import { POST_PRE_TAG_MAP } from './constants';
import { appName } from '../../config/defaultSettings';
/* eslint-disable */
/**
 * Parse all cookies from document.cookie into an object
 * @returns {Object} Key-value pairs of all cookies
 */
function parseCookies() {
  const cookies = document.cookie.split(';');
  const result = {};
  cookies.forEach(cookie => {
    const [name, value] = cookie.split('=');
    if (name && value !== undefined) {
      result[name.trim()] = value;
    }
  });
  return result;
}

// 获取存储在cookie中的token
export function getToken() {
  return parseCookies().token;
}

// 获取指定的cookie
export function getCookie(key) {
  return parseCookies()[key];
}

/**
 * 存储cookie
 * key-value,key就是cookie的名字，value为cookie值
 * @param {Object} data
 */
export function setCookie(data) {
  const keys = Object.keys(data);
  keys.forEach(it => {
    document.cookie = `${it}=${data[it]};path=/`;
  });
  // for (const key in data) {
  //   document.cookie = `${key}=${data[key]};path=/`;
  // }
}

// 移除指定的cookie
const SAFE_COOKIE_NAME = /^[a-zA-Z0-9_/.:-]+$/;
export function removeCookies(...keys) {
  const cookies = document.cookie.split(';');
  cookies.forEach(cookie => {
    const rawName = (cookie.split('=')[0] || '').trim();
    // 严格验证 cookie name，防止 Header Manipulation 攻击
    if (!rawName || !SAFE_COOKIE_NAME.test(rawName)) return;
    // 额外检查：确保不包含 CR/LF 等特殊字符
    if (/[\r\n;]/.test(rawName)) return;
    // 如果要删除指定的 keys，检查是否在 keys 列表中
    if (keys.length === 0 || keys.includes(rawName)) {
      document.cookie = `${rawName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  });
}

// 获取存储在cookie中的userType
export function getUserType() {
  return parseCookies().userType;
}

export function getAppName() {
  return window.localStorage.getItem('app_name');
}

// 加密
export function encrypt(data) {
  return Base64.encode(data);
}

// 解密
export function decrypt(data) {
  return Base64.decode(data);
}

export function getBasePath() {
  return `/${appName}`;
}

// 存储需要按路径区分的localStorage，如Auth-Token、userInfo
export function getItemPath(key, path) {
  const basePath = path || getBasePath();
  return `${basePath}:${key}`;
}

export function setLocalStorageWithPath(key, value, path) {
  const itemKey = getItemPath(key, path);
  window.localStorage.setItem(itemKey, value);
}

export function getLocalStorageWithPath(key, path) {
  const itemKey = getItemPath(key, path);
  return window.localStorage.getItem(itemKey);
}

export function removeLocalStorageWithPath(key, path) {
  const itemKey = getItemPath(key, path);
  return window.localStorage.removeItem(itemKey);
}

// userInfo相关
export function storeUserInfo(userInfo, path) {
  const basePath = path || getBasePath();
  const str = encrypt(JSON.stringify(userInfo));
  setLocalStorageWithPath('userInfo', str, basePath);
}

export function getUserInfo(path) {
  const basePath = path || getBasePath(); // 需要确认前缀
  let userInfo = getLocalStorageWithPath('userInfo', basePath);
  if (userInfo) {
    userInfo = decrypt(userInfo);
    try {
      return JSON.parse(userInfo);
    } catch (err) {
      return {};
    }
  }
  return {};
}

export function clearUserInfo(path) {
  const basePath = path || getBasePath();
  removeLocalStorageWithPath('userInfo', basePath);
}

// 公共设置方法
export function storeInfoByKey(key, Info, path) {
  const basePath = path || getBasePath();
  const str = encrypt(JSON.stringify(Info));
  setLocalStorageWithPath(key, str, basePath);
}

// 取值是对象：{},
export function getInfoByKey(key, path) {
  const basePath = path || getBasePath();
  let userInfo = getLocalStorageWithPath(key, basePath);
  if (userInfo) {
    userInfo = decrypt(userInfo);
    try {
      return JSON.parse(userInfo);
    } catch (err) {
      return {};
    }
  }
  return {};
}

// 取值是数组：[]
export function getInfoArrByKey(key, path) {
  const basePath = path || getBasePath();
  let userInfo = getLocalStorageWithPath(key, basePath);
  if (userInfo) {
    userInfo = decrypt(userInfo);
    try {
      return JSON.parse(userInfo);
    } catch (err) {
      return [];
    }
  }
  return [];
}

// 取值是字符串:''
export function getInfoStrByKey(key, path) {
  const basePath = path || getBasePath();
  let userInfo = getLocalStorageWithPath(key, basePath);
  if (userInfo) {
    userInfo = decrypt(userInfo);
    try {
      return JSON.parse(userInfo);
    } catch (err) {
      return '';
    }
  }
  return '';
}

// subsInfo相关>>>
// get

export function getCurrentSubsInfo(path) {
  const currentSubsInfo = getInfoByKey('currentSubsInfo', path);
  if (!isEmpty(currentSubsInfo)) {
    return currentSubsInfo;
  }
  return getInfoByKey('subsInfo', path);
}

export function getSubsInfo(path) {
  return getInfoByKey('subsInfo', path);
}

// set
export function updateCurrentSubsInfo(subsInfo, path) {
  storeInfoByKey('currentSubsInfo', subsInfo, path);
}

export function storeSubsInfo(subsInfo, path) {
  storeInfoByKey('subsInfo', subsInfo, path);
}

// subsInfo相关<<<

// custInfo相关>>>
// get
export function getCustInfo(path) {
  return getInfoByKey('custInfo', path);
}
// set
export function storeCustInfo(custInfo, path) {
  storeInfoByKey('custInfo', custInfo, path);
}
// custInfo相关<<<

// subsList相关>>>
// get
export function getSubsList(path) {
  return getInfoArrByKey('subsList', path);
}
// set
export function storeSubsList(subsInfo, path) {
  storeInfoByKey('subsList', subsInfo, path);
}
// subsList相关<<<

// 登录次数>>>
export function getLoginCount(account) {
  return window.localStorage.getItem(`/${appName}:${account}-loginCount`) || 0;
}
export function setLoginCount(account) {
  const oldAccount = getLoginCount(account);
  window.localStorage.setItem(`/${appName}:${account}-loginCount`, +oldAccount + 1);
}
// 登录次数<<<
// 清空LocalStorage
export function clearLocalStorage() {
  localStorage.removeItem('Auth-Token');
  localStorage.removeItem('Refresh-Token');
  removeCookies('Auth-Token');
  removeCookies('Refresh-Token');
  removeCookies(`/${appName}:Auth-Token`);
  removeLocalStorageWithPath('Auth-Token', `/${appName}`);
  removeLocalStorageWithPath('userInfo', `/${appName}`);
  removeLocalStorageWithPath('subsInfo', `/${appName}`);
  removeLocalStorageWithPath('pwd_expired', `/${appName}`);
  removeLocalStorageWithPath('currentSubsInfo', `/${appName}`);
}

// 安全取值
// demo: elvis(pageInfo, 'currentPage')
// elvis(object: Object, path: ?string)
// 如同groovy的elvis操作符`?`，例如`elvis(user, 'postalAddress.postalCode')`
// 等同于groovy的`user?.postalAddress?.postalCode`
export function elvis(object, path) {
  if (!object) return object;
  return path ? path.split('.').reduce((value, key) => value && value[key], object) : object;
}

// 安全取值 Array 对象
//  elvisArray(AccountList, 'data'),
export function elvisArray(object, path) {
  return elvis(object, path) || [];
}

// 日期格式转换
// formatDate(时间, 转换前的格式, 转换后的格式)
// 例：formatDate('20201216100835', 'YYYYMMDDhhmmss', 'MM/DD/YYYY hh:mm:ss')
// 结果：12/16/2020 10:08:35
export function formatDate(date, FrontFormat, afterFormat) {
  const data = moment(date, FrontFormat).format(afterFormat);
  if (data === 'Invalid date') {
    return '';
  }
  return data;
}

// 精确到小数点后两位
export function numberFix(number) {
  if (number) {
    return (number / 100).toFixed(2);
  }
  return 0;
}
// 新包查询接口跟换价格精度不一致
export function numberPower(number) {
  if (number) {
    return number * 100;
  }
  return 0;
}
// 获取当前路径
export function getPath() {
  const str = window.location.href;
  const index = str.lastIndexOf(':');
  const path = str.substring(0, index);
  return path;
}

// 签名校验数据获取
export function getSigncode(url, options) {
  const { data = {}, params = {}, headers = {} } = options;
  const authToken = headers['Auth-Token'] || getCookie('Auth-Token') || '';
  let signUrl = url.split('/ecare/webs/')[1] || url.split('/portal-web/')[1];
  let result = '';
  if (signUrl) {
    options.method = options.method.toUpperCase();
    if (options.method === 'GET') {
      if (!isEmpty(params)) {
        signUrl = `${signUrl}?${qs.stringify(params, { strictNullHandling: true })}`;
      } else if (signUrl.includes('?')) {
        const subIndex = signUrl.lastIndexOf('?');
        const urlParams = qs.stringify(qs.parse(signUrl.substr(subIndex + 1)), {
          strictNullHandling: true,
        });
        const reqUrl = signUrl.substring(0, subIndex);
        signUrl = `${reqUrl}?${urlParams}`;
      }
      const signCode = `/${signUrl}`;
      const shaParams = `${signCode}${authToken}32BytesString`.replace(/null/g, '');
      // headers新增一个参数sign_code
      result = sha256(shaParams);
    } else {
      let signCode = JSON.stringify(data);
      // 只保留数字和字母,剔除null
      signCode = signCode.replace(/[^a-zA-Z\d]/g, '');
      signCode = signCode.replace(/null/g, '');
      // headers新增一个参数sign_code
      result = sha256(`/${signUrl}${signCode}${authToken}32BytesString`);
    }
  }
  return {
    signcode: result,
    timestamp: new Date().getTime(),
  };
}

// GCP 签名校验数据获取
export function getGCPSigncode(url, options) {
  const { data = {}, params = {}, headers = {} } = options;
  // GCP 签名 atuhtoken 不能为空，加一个 时间戳 代替
  const timestamp = new Date().getTime();
  const authToken = headers['Auth-Token'] || getCookie('Auth-Token') || timestamp;
  let signUrl = url.split('/promotion-rest-boot/')[1];
  let result = '';
  if (signUrl) {
    options.method = options.method.toUpperCase();
    if (options.method === 'GET') {
      if (!isEmpty(params)) {
        signUrl = `${signUrl}?${qs.stringify(params, { strictNullHandling: true })}`;
      } else if (signUrl.includes('?')) {
        const subIndex = signUrl.lastIndexOf('?');
        const urlParams = qs.stringify(qs.parse(signUrl.substr(subIndex + 1)), {
          strictNullHandling: true,
        });
        const reqUrl = signUrl.substring(0, subIndex);
        signUrl = `${reqUrl}?${urlParams}`;
      }
      const signCode = `/${signUrl}`;
      const shaParams = `${signCode}${authToken}32BytesString`.replace(/null/g, '');
      // headers新增一个参数sign_code
      result = sha256(shaParams);
    } else {
      let signCode = JSON.stringify(data);
      // 只保留数字和字母,剔除null
      signCode = signCode.replace(/[^a-zA-Z0-9]/g, '');
      signCode = signCode.replace(/null/g, '');
      // headers新增一个参数sign_code
      result = sha256(`/${signUrl}${signCode}${authToken}32BytesString`);
    }
    return {
      timestamp,
      signcode: result,
      authtoken: authToken,
    };
  }
  return null;
}

export const scrollIntoView = () => {
  document.getElementById('root').scrollIntoView(true); // 为ture返回顶部，false为底部
};

// 设置cookie
export const invatationCookie = (name, value, seconds) => {
  // const seconds = seconds || 0; // seconds有值就直接赋值，没有为0
  let expires = '';
  if (seconds !== 0) {
    // 设置cookie生存时间
    const date = new Date();
    date.setTime(date.getTime() + seconds * 1000);
    expires = `; expires=${date.toGMTString()}`;
  }
  document.cookie = `${name}=${escape(value)}${expires}; path=/`; // 转码并赋值
};
// 获取cookie
export const getinvatationCookie = name => {
  // Token
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';'); // 把cookie分割成组
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]; // 取得字符串
    while (c.charAt(0) === ' ') {
      // 判断一下字符串有没有前导空格
      c = c.substring(1, c.length); // 有的话，从第二位开始取
    }
    if (c.indexOf(nameEQ) === 0) {
      // 如果含有我们要的name
      return unescape(c.substring(nameEQ.length, c.length)); // 解码并截取我们要值
    }
  }
  return false;
};

export const getQueryString = name => {
  // eslint-disable-next-line prefer-template
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
};

export const getPhoneType = () => {
  const ua = navigator.userAgent;
  const isWindowsPhone = /(?:Windows Phone)/.test(ua);
  const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
  const isAndroid = /(?:Android)/.test(ua);
  const isFireFox = /(?:Firefox)/.test(ua);
  // const isChrome = /(?:Chrome|CriOS)/.test(ua);
  const isTablet =
    /(?:iPad|PlayBook)/.test(ua) ||
    (isAndroid && !/(?:Mobile)/.test(ua)) ||
    (isFireFox && /(?:Tablet)/.test(ua));
  const isPhone = /(?:iPhone)/.test(ua) && !isTablet;
  const isPc = !isPhone && !isAndroid && !isSymbian;
  switch (true) {
    case isTablet:
      return 'tablet';
    case isPhone:
      return 'ios';
    case isAndroid:
      return 'android';
    case isPc:
      return 'web';
    default:
  }
  return null;
};

export const handleResize = () => {
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  const htmlDom = document.getElementsByTagName('html')[0];
  if (getPhoneType() === 'web') {
    htmlDom.style.fontSize = `${(100 / 1920) * htmlWidth}px`;
  } else {
    htmlDom.style.fontSize = `${(100 / 375) * htmlWidth}px`;
  }
};
/* eslint-disable */

// app userInfo相关
export function storeAppUserInfo(userInfo, path) {
  const basePath = path || getBasePath();
  // const str = encrypt(JSON.stringify(userInfo));
  const str = JSON.stringify(userInfo);
  setLocalStorageWithPath('appUserInfo', str, basePath);
}

export function getAppUserInfo(path) {
  const basePath = path || getBasePath(); // 需要确认前缀
  let userInfo = getLocalStorageWithPath('appUserInfo', basePath);
  if (userInfo) {
    // userInfo = decrypt(userInfo);
    try {
      return JSON.parse(userInfo);
    } catch (err) {
      return {};
    }
  }
  return {};
}

export function clearAppUserInfo(path) {
  const basePath = path || getBasePath();
  removeLocalStorageWithPath('appUserInfo', basePath);
}

export const getAppInfo = (callback, webFlag) => {
  const initAppStr = window.clp?.getLoginInfo() || '{}';
  const initApp = JSON.parse(initAppStr) || {};
  callback(initApp);
};

export const getUserTag = userInfo => {
  const isFwaUser =
    get(userInfo, 'userInfo.isFWAFlag') === 'Y' || get(userInfo, 'userInfo.isFWA') === 'Y';
  const fwaType = get(userInfo, 'userInfo.paymentModeCd');
  if (isFwaUser) {
    // 2100-预付费，1200-后付费
    return POST_PRE_TAG_MAP[fwaType];
  } else {
    return 'COMMON';
  }
};

// 获取设备类型
export const getOSInfo = () => {
  const ua = navigator.userAgent;
  const isWindowsPhone = /(?:Windows Phone)/.test(ua);
  const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
  const isAndroid = /(?:Android)/.test(ua);
  const isFireFox = /(?:Firefox)/.test(ua);
  // const isChrome = /(?:Chrome|CriOS)/.test(ua);
  const isTablet =
    /(?:iPad|PlayBook)/.test(ua) ||
    (isAndroid && !/(?:Mobile)/.test(ua)) ||
    (isFireFox && /(?:Tablet)/.test(ua));
  const isPhone = /(?:iPhone)/.test(ua) && !isTablet;
  const isPc = !isPhone && !isAndroid && !isSymbian;
  return {
    isTablet,
    isPhone,
    isAndroid,
    isPc,
  };
};

// 判断当前设备
export const getDeviceType = () => {
  return get(JSON.parse(localStorage.getItem('initApp')), 'platform');
};

/**
 * price金额
 * currencySymbol 单位
 */
export function getDisplayPrice(price, currencySymbol, symbolDisplay, flag) {
  if (flag && symbolDisplay === 'end') {
    return `${price}<font>${currencySymbol}</font>`;
  }
  if (flag && symbolDisplay !== 'end') {
    return `<font>${currencySymbol}</font>${price}`;
  }
  if (!flag && symbolDisplay === 'end') {
    return `${price}<font>${currencySymbol}</font>`;
  }
  return `<font>${currencySymbol}</font> ${price}`;
}
